import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@mint-lib/tw-components';

import { Separator } from './Separator.jsx';

type IconButtonProps = {
  onClick: () => void;
  icon?: React.ReactNode;
  color?: 'primary' | 'ai' | 'warning' | 'error';
  disabled?: boolean;
  separator?: boolean;
  /**
   * When provided, hovering the button reveals this content in a tooltip.
   * Icon buttons carry no label, so this is the only way to name the action
   * for sighted users.
   *
   * @example
   * <IconButton icon={<TrashCan />} tooltip={t('Delete')} onClick={...} />
   */
  tooltip?: React.ReactNode;
  ariaLabel?: string;
  dataDdActionName?: string;
};

export function IconButton({
  onClick,
  icon,
  color,
  disabled,
  separator,
  tooltip,
  ariaLabel,
  dataDdActionName,
}: Readonly<IconButtonProps>) {
  const button = (
    <Button
      aria-label={ariaLabel}
      data-dd-action-name={dataDdActionName}
      icon
      variant="text"
      color={color ?? 'primary'}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </Button>
  );

  return (
    <>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="top">{tooltip}</TooltipContent>
        </Tooltip>
      ) : (
        button
      )}
      {separator && <Separator />}
    </>
  );
}
